export default __webpack_public_path__ + "media/zurb/img/events/soapbox/soapbox-img4-6b848ab27948bb9ec4641f20da4e98c3.png";